import type { Photo } from "../../types";

type ProfilePhotoSource = {
  photos?: Photo[];
  profilePictureId?: string | null;
};

export function profilePhotoItems(profile: ProfilePhotoSource) {
  return [...(profile.photos || [])].sort(
    (a, b) => Number(b.isProfilePicture) - Number(a.isProfilePicture) || a.order - b.order,
  );
}

export function profilePicturePhotoId(
  profile: ProfilePhotoSource,
  photos = profilePhotoItems(profile),
) {
  return profile.profilePictureId
    || photos.find((photo) => photo.isProfilePicture)?.id
    || photos[0]?.id
    || null;
}

export function profileGalleryPhotoItems(
  profile: ProfilePhotoSource,
  photos = profilePhotoItems(profile),
) {
  const profilePictureId = profilePicturePhotoId(profile, photos);
  return photos.filter(
    (photo) => !photo.isProfilePicture && photo.id !== profilePictureId,
  );
}
